import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {LocalStorageService, UserService} from '../../_services';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {AboutUsComponent} from '../about-us/about-us.component';
import {TermsAndConditionComponent} from '../terms-condition/terms-condition.component';
import {PrivacyComponent} from '../privacy/privacy.component';
import {ChooseEmotionComponent} from '../../modules/user/auth/reports/choose-emotion/choose-emotion.component';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-why-menu-options-modal',
  template: `
    <section class="menu--container">
      <div>
        <article class="flex-row ion-justify-content-end">
          <!--<div>
            <ion-label class="input-text-label h2 dark bold">{{"menu.menu" | translate}}</ion-label>
          </div>-->
          <div (click)="dismiss()" class="close-container">
            <ion-icon class="icon add__color primary-shade" name="close-outline"></ion-icon>
          </div>
        </article>
        <article class="pd-top-40 pd-bottom-40" style="display:flex;flex-direction: column;gap: 40px">
          <div class="ion-text-center">
            <ion-label class="input-text-label p l-shade medium show-cursor"
                       (click)="aboutPage()">{{"menu.about" | translate}}</ion-label>
          </div>
          <div class="ion-text-center">
            <ion-label class="input-text-label p l-shade medium show-cursor"
                       (click)="profile()">Profile
            </ion-label>
          </div>
          <div class="ion-text-center">
            <ion-label class="input-text-label p l-shade medium show-cursor" (click)="chooseEmotion()">
              Colour Guide
            </ion-label>
          </div>
          <div class="ion-text-center">
            <ion-label class="input-text-label p l-shade medium show-cursor"
                       (click)="termsPage()">Terms & Conditions
            </ion-label>
          </div>
          <div class="ion-text-center">
            <ion-label class="input-text-label p l-shade medium show-cursor" (click)="feedback()">
              Feedback
            </ion-label>
          </div>
          <div *ngIf="!isUserLoggedIn">
            <div style="height: 1px; width: 100%; background-color: var(--ion-color-medium-tint);"></div>
          </div>
          <div *ngIf="!isUserLoggedIn">
            <ion-button type="submit"
                        class="app-btn full-width" (click)="signIn()">{{'sign_in.submit' | translate}}</ion-button>
            <div class="ion-text-center pd-top-24">
              <ion-label class="input-text-label p2 primary-shade ft-medium link ion-text-center"
                         (click)="navigateToSignUp()">CREATE AN ACCOUNT
              </ion-label>
            </div>
          </div>
        </article>
      </div>
    </section>`,
  styles: [`

    .menu--container {
      padding: 40px 36px 80px;
      height: 100%;
      --background: url("/assets/img/png/1x/MAPIMO-bg-main.png") center center / 100% 100% no-repeat;
      background: url("/assets/img/png/1x/MAPIMO-bg-main.png") center center / 100% 100% no-repeat;
    }

    @media only screen and (min-width: 600px) {
      .menu--container {
        height: 100%;
        --background: url("/assets/img/png/1x/MAPIMO-bg-main.png") center center / 100% 100% no-repeat;
        background: url("/assets/img/png/1x/MAPIMO-bg-main.png") center center / 100% 100% no-repeat;
      }
    }

    .close-container {
      width: 26px;
      height: 29px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  `]
})
export class MenuOptionsModalPage {
  isUserLoggedIn: any;
  projectType: any;

  constructor(public translate: TranslateService,
              private localStorageService: LocalStorageService,
              public modalController: ModalController,
              private router: Router) {
    this.isUserLoggedIn = this.localStorageService.get(environment.currentUser);
    this.projectType = this.localStorageService.get('projectType');
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true
    });
  }

  logOut() {
    this.router.navigate(['./log-out']);
    this.dismiss();
  }

  async privacyPage() {
    // this.router.navigate(['./privacy-policy']);
    this.dismiss();
    const modal = await this.modalController.create({
      component: PrivacyComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  async aboutPage() {
    this.dismiss();
    // this.router.navigate(['about']);
    const modal = await this.modalController.create({
      component: AboutUsComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  async termsPage() {
    this.dismiss();
    // this.router.navigate(['./terms-condition']);
    const modal = await this.modalController.create({
      component: TermsAndConditionComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  contactPage() {
    this.dismiss();
    this.router.navigate(['./contact']);
  }

  feedbackPage() {
    this.dismiss();
    this.router.navigate(['./feedback']);
  }

  async chooseEmotion() {
    const modal = await this.modalController.create({
      component: ChooseEmotionComponent,
      componentProps: {
        fromMapFilter: true
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  feedback() {
    this.dismiss();
    this.router.navigate(['./feedback']);
  }

  navigateToSignUp() {
    this.dismiss();
    this.router.navigate(['./user/auth/sign-up']);
  }

  signIn() {
    this.dismiss();
    this.router.navigate(['./user/auth/sign-in/' + this.projectType.ref]);
  }

  profile() {
    this.dismiss();
    if (this.isUserLoggedIn) {
      this.router.navigate(['./profile']);
    } else {
      this.router.navigate(['./user/auth/sign-in/' + this.projectType.ref]);
    }
  }
}
